var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: true } },
    [
      _c(
        "w-card",
        { staticClass: "warning", attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("carpass-description-response"))),
          ]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            _vm._l(_vm.value.errors, function (err, i) {
              return _c(
                "w-list-item",
                { key: i },
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(err.field) + " " + _vm._s(err.message)),
                  ]),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "w-card-actions",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }